import {observable, computed, action} from 'mobx';
import {genUid} from '../../utils';

class Error {
  constructor(id, scope, message) {
    this.scope = scope;
    this.message = message;
    this.id = id;
  }

}

export class Flasher {
  @observable state = {
    login: undefined,
    logout: undefined,

    other: undefined,
  }

  @observable errors = [];

  @computed get anyInProgress() {
    for(let k in this.state) {
      if(this.state[k]) {
        return true;
      }
    }
    return false;
  }

  constructor() {

  }

  async runWith(action, fn) {
    try {
      action(true);
      await fn();
    }
    finally {
      action(false);
    }
  }

  @action.bound setOther(msg) {
    //this.state.other = msg;
  }

  @action.bound reportError(scope, message) {
    this.errors.push(new Error(genUid(), scope, message));
  }

  @action.bound handleError(e) {
    if(e.backendMessage) {
      this.reportError('Error', e.backendMessage);
    } else {
      this.reportError('Exception', '' + e);
    }
  }

  @action.bound dismissError(id) {
    const idx = this.errors.findIndex(o => o.id === id);
    if(idx > -1) {
      this.errors.splice(idx, 1);
    }
  }

  @action.bound 

  @action.bound login(state) {
    this.state.login = state;
  }

  @action.bound logout(state) {
    this.state.logout = state;
  }

  @action.bound showSpinner(state) {
    this.state.other = state;
  }
}


// WEBPACK FOOTER //
// ./src/view/Flasher/model.js